import { useEffect, useState, useCallback } from "react";

/**
 * Returns the number of pending offline operations in the SW queue.
 * Polls every 15 seconds + listens for SW messages.
 */
export default function useOfflineQueueCount() {
  const [count, setCount] = useState(0);
  const [online, setOnline] = useState(navigator.onLine);

  const refresh = useCallback(() => {
    if (navigator.serviceWorker?.controller) {
      navigator.serviceWorker.controller.postMessage({ type: "GET_OFFLINE_QUEUE" });
    }
  }, []);

  useEffect(() => {
    const onMsg = (e) => {
      if (e.data?.type === "OFFLINE_QUEUE_LIST") {
        setCount(e.data.items?.length || 0);
      }
      if (e.data?.type === "OFFLINE_QUEUE_UPDATED" || e.data?.type === "OFFLINE_SYNC_COMPLETE") {
        refresh();
      }
    };
    if (navigator.serviceWorker) {
      navigator.serviceWorker.addEventListener("message", onMsg);
    }
    refresh();
    const interval = setInterval(refresh, 15000);

    const onOn = () => { setOnline(true); refresh(); };
    const onOff = () => setOnline(false);
    window.addEventListener("online", onOn);
    window.addEventListener("offline", onOff);
    return () => {
      navigator.serviceWorker?.removeEventListener("message", onMsg);
      window.removeEventListener("online", onOn);
      window.removeEventListener("offline", onOff);
      clearInterval(interval);
    };
  }, [refresh]);

  return { count, online, refresh };
}
